import React, { useState, useEffect, useContext, useRef } from "react";
import Moviecard from "./Moviecard";
import { Link, useLocation } from "react-router-dom";
import { fetchSectionList, fetchSearch } from "./Api";
import { Contextone } from "./Context";
import subscribe from "../images/premium.png";
import styled from 'styled-components';
import rentIcon from "../images/rentIcon.png";
import Cookies from "js-cookie";
import { ShimmerThumbnail } from "react-shimmer-effects";


const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;


const ShimmerRow = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', marginTop: '15vh' }}>
    {[...Array(14)].map((_, index) => (
      <ShimmerContainer key={index} />
    ))}
  </div>
);
const Newspage = () => {
  const location = useLocation();
  const url = location.pathname;
  const [sectionlist, setSectionlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [value, setValue] = useState("");
  const [videoData, setVideoData] = useState([]);
  const [seriesData, setSeriesData] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isPageUrl, setLastPageUrl] = useState(null);
  const countercontext = useContext(Contextone);
  const searchRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState({});
  const logo = countercontext.isLogo;
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;
  const userid = Cookies.get("userid");
  const [isNewsData, setNewsData] = useState([]);
  
  const scrollContainerRef = useRef(null); 

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && searchQuery.trim() !== '') {
        setValue(searchQuery);
        setVideoData([]);
        setSeriesData([]); 
        setLoading(true);
        fetchData(1, searchQuery);
    }
  };

 const fetchData = async (pageNum, value) => {
     if (loadingMore) return;
     try {
         const sectionData = await fetchSearch(apiUrl, value, pageNum);
         
 
         const newVideos = Array.isArray(sectionData.video) ? sectionData.video : [];
         const newSeries = Array.isArray(sectionData.tvshow) ? sectionData.tvshow : [];
 
         setVideoData((prev) => [...prev, ...newVideos]);
         setSeriesData((prev) => [...prev, ...newSeries]);
 
         if (sectionData.next_page_url) {
             setLastPageUrl(sectionData.next_page_url);
             setPage((prevPage) => prevPage + 1);
         } else {
             setLastPageUrl(null); 
         }
     } catch (error) {
         console.error("Error:", error);
     } finally {
         setLoadingMore(false);
         setLoading(false);
     }
 };
 
 
   const loadMoreData = () => {
     if (!loading && isPageUrl && !loadingMore) {
         setLoadingMore(true);
         fetchData(page, value); 
     }
 };
 
 useEffect(() => {
         if (!scrollContainerRef.current) return;
     
         const observer = new IntersectionObserver(
             (entries) => {
                 if (entries[0].isIntersecting && isPageUrl && !loadingMore && !loading) {
                     loadMoreData();
                 }
             },
             { threshold: 0.1 }
         );
     
         observer.observe(scrollContainerRef.current);
     
         return () => observer.disconnect();
     }, [isPageUrl, page, loadingMore, loading]);

  

  useEffect(() => {
    const fetchSectionData = async () => {
      setLoading(true);
      try {
        const sectionData = await fetchSectionList(apiUrl, 5, 2, 0);
        setSectionlist(sectionData.result[0] || []);
      } catch (error) {
        console.error("Error fetching section data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSectionData();
  }, [apiUrl]);

  const addDefaultImg = (ev) => {
    ev.target.src = logo;
  };

  const handleImageLoad = (index) => {
    setImageLoaded((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };

 const slugify = (text) => {
    return text.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
  };
  
  const decodeVal = (str) => {
    return btoa(str);
  }
  
  const createEncodedData = (id, type_id, video_type, upcoming_type) => {
    const str = `${id}-${type_id}-${video_type}-${upcoming_type}`; 
    return decodeVal(str); 
  };
  
  useEffect(()=>{
    setNewsData(videoData.filter((news)=>news.type_id === 5))
},[videoData])

  return (
    <div className="search-page">
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <div className="search-container" ref={searchRef}>
        <i className="fa fa-search"></i>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search"
          className="search-input"
          onKeyDown={handleKeyPress}    
        />
      </div>
      {loading ? (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <ShimmerRow />
      </div>
      ) :  isNewsData[0]  ? (
        <div className="view-list">
        {isNewsData.map((movie, key) => (
          <div className="custom-div" key={`${movie.id}-${key}`} ref={scrollContainerRef}>
              <div className="card movie-card">
                  {/* {movie.type_id === 5 && movie.name ? */}
                  <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`} >
                  {(movie.is_premium || movie.is_rent !== 0) && (
                        <img
                          src={movie.is_premium ? subscribe : rentIcon}
                          className={`premium-img ${movie.is_premium ? 'premium-style' : ''}`}
                          alt="Premium/Rent Icon"
                        />
                      )}
                      {movie.thumbnail ? (
                          <img src={imageLoaded[key] ? movie.thumbnail : logo} 
                          onLoad={() => handleImageLoad(key)}
                          onError={addDefaultImg}
                          className="img-top" alt={movie.name} style={{ height: '230px' }} />
                      ) : (
                          <img src={imageLoaded[key] ? movie.image : logo} 
                          onLoad={() => handleImageLoad(key)} 
                          onError={addDefaultImg}
                          className="img-top" alt={movie.name} style={{ height: '230px' }} />
                      )}
                  </Link>  
              </div>
            </div>
        ))}
    </div>
    ):  (value && isNewsData.length == 0) ?
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color:'white' }}>
        <h2>No data available</h2>
      </div>
      :
    sectionlist.data && (
      // sectionlist.map((mtype) => (
        <div className="scroll-container" >
          {sectionlist.data.length > 0 && (
            <>
              <div className="view-screen">
                {sectionlist.data.map((movie, key,type) => (
                  <div className="custom-div" key={key}>
                    <div className="card movie-card">
                      {movie.is_live_url ? (
                        userid ? (
                          <Link
                            to={{
                              pathname: "/play/0/0/0",
                              state: { url: movie.video_320 },
                            }}
                          >
                            <div className="live-wrapper">
                              <img
                                src={movie.thumbnail}
                                className="img-top"
                                alt="Live Content"
                                style={{ height: "230px" }}
                              />
                            </div>
                          </Link>
                        ) : (
                          <Link to="/login">
                            <div className="live-wrapper">
                              <img
                                src={movie.thumbnail}
                                className="img-top"
                                alt="Live Content"
                                style={{ height: "230px" }}
                              />
                            </div>
                          </Link>
                        )
                      ) : (
                        <Link to={`/search/${slugify(movie.name)}/${createEncodedData(movie.id,movie.type_id, movie.video_type, movie.upcoming_type)}`}>
                          {(movie.is_premium || movie.is_rent !== 0) && (
                            <img
                              src={movie.is_premium ? subscribe : rentIcon}
                              className={`premium-img ${
                                movie.is_premium ? "premium-style" : ""
                              }`}
                              alt="Premium/Rent Icon"
                            />
                          )}
                          <img
                            src={movie.thumbnail || movie.image}
                            className="img-top"
                            alt={movie.name}
                            style={{ height: "230px" }}
                          />
                        </Link>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      // ))
    )}
    </div>
  );
};

export default Newspage;
